<template>
  <div ref="rightHolder" id="rightHolder" class="right-holder">
    <div v-if="UploadLoading" class="rp-circle-box">
      <CircleProgress :is-bg-shadow="true" style="  height: 45px; width: 45px;" :percent="percent" />
      <h5 class="rp-circle-saving">SAVING...</h5>
    </div>
    <ItemDetail v-if="selectionCount === 1" />
    <ItemQueue v-if="selectionCount > 1" />
    <DataBlock editName="DATA" type="resource" />
    <DropDown v-if="RMTPermission" />
    <KeywordSelector type="tags" />
    <KeywordSelector type="collections" />
    <KeywordSelector type="permissions" />
    <ErrorDisplay></ErrorDisplay>
    <RightPanelButtons v-if="RMTPermission" :save="handleSave" :cancel="handleResourceCancel" />
  </div>
</template>

<script>
import ItemDetail from '@/components/libraries/search/ItemDetail';
import ItemQueue from '@/components/libraries/search/ItemQueue';
import DataBlock from '@/components/rmt/DataBlock';
import KeywordSelector from '@/components/rmt/KeywordSelector';
import RightPanelButtons from '@/components/rmt/RightPanelButtons';
import DropDown from '@/components/rmt/DropDown';
import { mapStores, storeToRefs } from 'pinia/dist/pinia';
import { useRMTStore } from '@/store/RMTStore';
import { useModalStore } from '@/store/ModalStore';
import { useIdentityStore } from '@/store/IdentityStore';
import { useAuthStore } from '@/store/auth.store';
import ErrorDisplay from '@/components/rmt/ErrorDisplay';
import CircleProgress from 'vue3-circle-progress';
import { useResourceStore } from '@/store/ResourceStore';

export default {
  name: 'ResourcePanel',
  components: {
    ErrorDisplay,
    ItemDetail,
    ItemQueue,
    DataBlock,
    KeywordSelector,
    RightPanelButtons,
    DropDown,
    CircleProgress
  },
  setup () {
    const RMTStore = useRMTStore();
    const { RMTSearchType, panelIsHidden, RMTPermission, RMTEditMode } = storeToRefs(RMTStore);
    const identityStore = useIdentityStore();
    const authStore = useAuthStore();
    const modalStore = useModalStore();
    return {
      RMTStore,
      RMTSearchType,
      RMTPermission,
      RMTEditMode,
      panelIsHidden,
      identityStore,
      authStore,
      modalStore
    };
  },
  computed: {
    ...mapStores(useRMTStore, useModalStore),
    UploadLoading () {
      const resourceStore = useResourceStore();
      return resourceStore.uploadLoading;
    },
    percent () {
      const resourceStore = useResourceStore();
      console.log(resourceStore.downloadPercent);
      return resourceStore.percent;
    },
    inUploadMode () {
      const RMTStore = useRMTStore();
      return RMTStore.inUploadMode;
    },
    uploadedFileData () {
      const RMTStore = useRMTStore();
      return RMTStore.uploadedFileData;
    },
    RMTSearchType () {
      const RMTStore = useRMTStore();
      return RMTStore.getSearchType;
    },
    selectionCount () {
      const RMTStore = useRMTStore();
      return RMTStore.selectedResources.length;
    },
    tagsForSelectedResource () {
      const RMTStore = useRMTStore();
      return RMTStore.tagsForSelectedResource;
    },
  },
  methods: {
    hidePanel () {
      this.RMTStore.setPanelIsHidden(true);
    },
    handleResourceCancel (e) {
      // TODO: add mode in which if nothing has been edited, hitting cancel doesn't require a prompt
      e.stopImmediatePropagation();
      this.modalStore.setModalObj({
        promptLabel: 'Cancel Resource Edit',
        promptDescription: 'Are you sure you want to cancel your edits?',
        showInput: false,
        buttonALabel: 'Cancel',
        buttonAFunc: this.cancelPrompt,
        buttonBLabel: 'CONFIRM',
        buttonBFunc: this.confirmCancelEdit
      });
      this.modalStore.showModal('prompt');
    },
    cancelPrompt () {
      this.modalStore.hideModal();
    },
    confirmCancelEdit () {
      this.RMTStore.clearAll();
      this.modalStore.hideModal();
      if (this.RMTStore.inUploadMode) {
        this.RMTStore.uploadCancel();
      }
    },
    handleUploadCancel () {
      this.RMTStore.setPanelIsHidden(true);
      this.RMTStore.uploadedFileData = [];
      this.RMTStore.uploadedFiles = [];
      this.RMTStore.filterUploadResources = [];
      this.RMTStore.setSelectedItemNum(0);
      this.RMTStore.isEdit = false;
      this.RMTStore.data = [
        { label: 'file name', placeholder: 'name_of_file.jpg', value: 'resourceUri' },
        { label: 'title', placeholder: 'Image Title', value: 'name' },
        { label: 'description', placeholder: 'Image Description', value: 'description' },
        { label: 'alt tag', placeholder: 'Alt tag', value: 'alt' }
      ];
      this.RMTStore.inUploadMode = false;
    },

    handleSave (e) {

      e.stopImmediatePropagation();
      this.RMTStore.saveStuff();

    },
    setRMTOn () {
      let permission = this.identityStore.getRMTPermission(true);
      this.RMTStore.RMTPermission = permission;
    },
    setRMTOff () {
      let permission = this.identityStore.getRMTPermission(false);
      this.RMTStore.RMTPermission = permission;
    }
  }
};
</script>

<style scoped>
.right-holder {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-right: 10px;
  overflow-y: auto;

}
.rp-circle-box{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
}
.rp-circle-saving {
  padding-top: 5px;
    font-size: 10px;
}
</style>